import { PaletteOptions } from '@mui/material';

const DarkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#1976d2',
  },
  secondary: {
    main: '#fff',
    contrastText: '#1d252d',
  },
  success: {
    main: '#29FF82',
    contrastText: '#1d252d',
  },
  info: {
    main: '#fff',
    contrastText: '#1d252d',
  },
  warning: {
    main: '#FFF73D',
    contrastText: '#1d252d',
  },
  background: {
    default: '#1d252d',
    paper: '#1d252d',
  },
  text: {
    secondary: '#ffffffcf',
  },
};

export default DarkPalette;
